import httpClient from "../http/http-client";
import { IGreenHouseGasUnit } from './green-house-gas-units.model';

export default class GreenHouseGasUnitsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IGreenHouseGasUnit[]> {
    return this.http.get(`greenhouse-gas-unit`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllWithPagination(searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IGreenHouseGasUnit[] }> {
    return this.http.get(`greenhouse-gas-unit?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${searchQuery ? `&nameIncludes=${searchQuery}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}
